import { Typography } from '@mui/material';

export const SectionTitle = ({ label }: { label: string }) => (
  <Typography variant="h5" sx={{ mb: 2 }}>
    {label}
  </Typography>
);
